<div class="page-title-area">
    <div class="container-fluid">
        <div class="page-title-content">
            <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">Bulk Messenger</h2>
            <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Bulk Messenger</li>
            </ul>
        </div>
    </div>

</div>

<section class="team-area ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">

                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/receipt.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-sm-2 ">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Recipient Management
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Import and manage large contact lists. This should include features like segmentation,
                            filtering, and group creation for targeted campaigns.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Message Personalization
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Personalize messages with user data like name, location, or purchase history for a more
                            engaging experience.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Personalization.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Scheduling.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Message Scheduling
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Schedule messages to be sent at specific times or in response to triggers (e.g., abandoned
                            cart reminders).
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Reporting & Analytics
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Track message delivery rates, open rates, click-through rates, and other key metrics to
                            measure campaign performance and optimize future efforts.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Analytics.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/api-int.png" alt="image"  style="max-width: 70% !important; "/>
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            API Integrations
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Integrate with CRM, marketing automation, or e-commerce platforms for a seamless workflow
                            and data exchange.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Security
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Ensure secure data storage and transmission with features like encryption and access
                            controls.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/security.png" alt="image" style="max-width: 55% !important;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Scalability.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Scalability
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            The API should be able to handle large volumes of messages without compromising performance.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Support for Multiple Languages
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Engage your audience in conversation in their native tongue to increase consumer engagement.
                            Gain the trust of your clients by communicating with them in their native tongue from
                            anywhere in the globe.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/robotic-support.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="warpper container-fluid">
        <input class="radio" id="one" name="group" type="radio" checked>
        <input class="radio" id="two" name="group" type="radio">
        <input class="radio" id="three" name="group" type="radio">
        <div class="tabs">
            <label class="tab" id="one-tab" for="one">Transactional Messages</label>
            <label class="tab" id="two-tab" for="two">Promotional Messages</label>
            <label class="tab" id="three-tab" for="three">Informational Messages</label>
        </div>
        <div class="panels">
            <div class="panel" id="one-panel">
                <div class="row mt-5 mt-md-3 row-cols-1 row-cols-sm-1 row-cols-md-3 justify-content-center">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-key"></i>
                            </div>
                            <h3>One-Time Passwords (OTPs)</h3>
                            <p>
                                Used for login verification, password resets, and two-factor authentication. <br> (e.g.,
                                "Your OTP for [Website Name] is 123456.")
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-arrows-down-to-people"></i>
                            </div>
                            <h3> Order and Appointment Confirmations</h3>
                            <p>
                                Provide confirmation details for purchases, bookings, or reservations. <br> (e.g., "Your order #12345 for [Store Name] has been confirmed. It will arrive by [date].")
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-shopping-cart"></i>
                            </div>
                            <h3> Delivery Notifications</h3>
                            <p>
                                Inform customers about the status of their deliveries and provide tracking information. <br> (e.g., "Your package from [Company Name] is out for delivery today. Track it here: [link]")
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-money"></i>
                            </div>
                            <h3> Billing and Payment Reminders</h3>
                            <p>
                                Send reminders about upcoming invoices or due payments. <br> (e.g., "A friendly reminder that your payment of $[amount] for [service] is due on [date].")
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="panel" id="two-panel">
                <div class="row mt-5 mt-md-3 row-cols-1 row-cols-sm-1 row-cols-md-3 justify-content-center">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-comments-o"></i>
                            </div>
                            <h3>Welcome Messages</h3>
                            <p>
                                Greet new users or customers and introduce your brand. <br> (e.g., "Welcome to [Company Name], [Name]! We're excited to have you on board.")
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-shopping-cart"></i>
                            </div>
                            <h3> Flash Sales & Discount Offers</h3>
                            <p>
                                Announce limited time offers and promotions to drive sales. <br> (e.g., "Get 20% off your next purchase with code 'SUMMER20' at [Website Name]!")
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-calendar"></i>
                            </div>
                            <h3> Event Invitations</h3>
                            <p>
                                Invite users to upcoming webinars, workshops, or other events. <br> (e.g., "Join us for a free webinar on [Topic] on [Date]! Register here: [link]")
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-product-hunt"></i>
                            </div>
                            <h3> Product Updates & New Launches</h3>
                            <p>
                                Inform users about new products, features, or updates to your service. <br>(e.g., "Introducing the all-new [Product Name]! Learn more here: [link]")
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="panel" id="three-panel">
                <div class="row mt-5 mt-md-3 row-cols-1 row-cols-sm-1 row-cols-md-3 justify-content-center">
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-user-secret"></i>
                            </div>
                            <h3> Account Updates</h3>
                            <p>
                                Notify users about changes to their account settings, security procedures, or privacy policies. <br> (e.g., "Important update: We've updated our privacy policy. Learn more here: [link]")
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-commenting"></i>
                            </div>
                            <h3> Survey & Feedback Requests</h3>
                            <p>
                                Collect user feedback through surveys or polls to improve your products or services. <br> (e.g., "Help us improve! Share your feedback in our quick survey: [link]")
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-bell"></i>
                            </div>
                            <h3> Customer Support Notifications</h3>
                            <p>
                                Inform users about resolved issues or updates related to their support tickets. <br> (e.g., "Your support ticket #1234 has been resolved. View details here: [link]")
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-money-check-dollar"></i>
                            </div>
                            <h3> News & Announcements</h3>
                            <p>
                                Share important company news, announcements, or upcoming events. <br> (e.g., "[Company Name] is proud to announce our partnership with [Partner Name]! Learn more here: [link]")
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>


    <div class="container-fluid">
      

        <div class="pricing">
            <h3 style="text-align: center; font-size: 24px; ">Pricing</h3>
            <div class="container">
            <table>
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Product Name</th>
                        <th>Quantity Slab</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>SMS</td>
                        <td>100 @30 Paise</td>
                        <td>Rs. 30/-</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>SMS</td>
                        <td>1,000 @ 25 Paise</td>
                        <td>Rs. 250/-</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>SMS</td>
                        <td>5,000 @ 22 Paise</td>
                        <td>Rs. 1,100/-</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>SMS</td>
                        <td>10,000 @ 20 Paise</td>
                        <td>Rs. 2,000/-</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>SMS</td>
                        <td>25,000 @ 17 Paise</td>
                        <td>Rs. 4,250/-</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>SMS</td>
                        <td>50,000 @ 16 Paise</td>
                        <td>Rs. 8,000/-</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>SMS</td>
                        <td>1 Lakh @ 15 Paise</td>
                        <td>Rs. 15,000/-</td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>SMS</td>
                        <td>5 Lakh @ 13 Paise</td>
                        <td>Rs. 65,000/-</td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td>SMS</td>
                        <td>10 Lakh @ 12 Paise</td>
                        <td>Rs. 1,20,000/-</td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>SMS</td>
                        <td>50 Lakh @ 11 Paise</td>
                        <td>Rs. 5,50,000/-</td>
                    </tr>
                    <tr>
                        <td>11</td>
                        <td>SMS</td>
                        <td>1 Crore @ 10 Paise</td>
                        <td>Rs. 10,00,000/-</td>
                    </tr>
                    <tr>
                        <td>12</td>
                        <td>SMS</td>
                        <td>1 Crore+ @ 9 Paise</td>
                        <td>Contact to Sales</td>
                    </tr>
                </tbody>
            </table>
        </div>
            <h3>Pricing: (GST Exclusive, as applicable)</h3>
        </div>
        
    </div>


</section>
<div class="full-row" #seprator id="seprator">
    <div class="container-fluid">
        <h6>
            Want to Improve the Experience of Your Customers? Our Dedicated Team Is Here to Help You Out!


        </h6>
        <a class="btns btn-primarys" routerLink="/contact">
            CONTACT US
        </a>
    </div>
</div>

<!-- ADVERTISERS SERVICE CARD -->